import { UI_PRIMITIVE__tabs, UI_PRIMITIVE__tabs_list, UI_PRIMITIVE__tabs_trigger } from '@/components/ui/UI_PRIMITIVE__tabs';
import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { EPagesMobileTabs } from '@/enums/EPagesMobileTabs';
import { ReactNode } from 'react';

interface Props {
  children: React.ReactNode;
  tabs: string[];
  icons: ReactNode[];
  className?: string;
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
}

export function LayoutPageMobileWithTabs({ children, tabs, icons, className, activeTab, setActiveTab }: Props) {
  function render_sidebar_navigation() {
    let out = <div className={`h-[${CONSTANTS__client.MOBILE_TOPBAR_HEIGHT}px]`}></div>;

    return out;
  }

  return (
    <div className={`bg-component pb-5 w-screen h-screen ${className}`}>
      {render_sidebar_navigation()}
      <UI_PRIMITIVE__tabs
        defaultValue={tabs[0]}
        value={activeTab}
        onValueChange={(value: string) => setActiveTab(value)}
        className="w-full !h-[calc(100vh-70px)] flex flex-col justify-between bg-component"
      >
        <div className={`${activeTab === EPagesMobileTabs.GRID2D ? 'px-0' : 'px-5'} w-full h-full`}>{children}</div>
        <div className="w-full flex justify-center justify-center mt-2">
          <UI_PRIMITIVE__tabs_list
            style={{
              gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))`,
            }}
            className="grid w-full mx-5  !bg-bar"
          >
            {tabs.map((tab, index) => (
              <UI_PRIMITIVE__tabs_trigger key={tab} value={tab} className=" dark:data-[state=active]:bg-component">
                {/* todo: baz icons */}
                {icons[index]}
              </UI_PRIMITIVE__tabs_trigger>
            ))}
          </UI_PRIMITIVE__tabs_list>
        </div>
      </UI_PRIMITIVE__tabs>
    </div>
  );
}
